module.exports = __webpack_public_path__ + "img/brain-icon.d53f7d28.png";